// extracted by mini-css-extract-plugin
export var addButton = "_i8-0";
export var border = "_i8-8";
export var check = "_i8-h";
export var danger = "_i8-6";
export var dropdownContainer = "_i8-1";
export var editModalBody = "_i8-j";
export var footerContainer = "_i8-i";
export var fullWidth = "_i8-a";
export var hide = "_i8-9";
export var icon = "_i8-3";
export var input = "_i8-7";
export var inputFlex = "_i8-b";
export var inputWrapper = "_i8-c";
export var manualFocus = "_i8-5";
export var optionButton = "_i8-4";
export var pillWrapper = "_i8-e";
export var pointer = "_i8-2";
export var showOverflow = "_i8-f";
export var tagsFlex = "_i8-d";
export var xButton = "_i8-g";